import React from 'react'
import {
  AccountAndPlansTitle,
  AccountAndPlansWrapper,
  AccountPlanOptionWrapper,
  AccountsAndPlansStyles,
  AccountsAndPlansTitlesWrapper,
} from 'Features/accountSettings/routes/AccountSettings/AccountsAndPlans/AccountsAndPlans.styles'
import { useTranslation } from 'react-i18next'
import { useGetReactivationAccounts } from 'Features/ReactivationPage/api/getReactivationAccounts'
import { AccountPlansRow } from 'Features/accountSettings/routes/AccountSettings/AccountsAndPlans/AccountPlansRow'
import { RadioButtonGroup } from '@clickcease/cc-client-components-lib'

type AccountsAndPlansProps = {
  selectedAccount?: number
  setSelectedAccount: (id: number) => void
}

export const AccountsAndPlans = ({
  selectedAccount,
  setSelectedAccount,
}: AccountsAndPlansProps) => {
  const { data: accounts } = useGetReactivationAccounts()
  const { t } = useTranslation('accountSettings')
  const renderAccountsWithPlans = () => {
    return accounts.map((account) => {
      return (
        <AccountPlanOptionWrapper selected={selectedAccount === account.id} key={account.id}>
          <RadioButtonGroup
            options={[
              {
                value: account.id.toString(),
                children: <AccountPlansRow account={account} />,
              },
            ]}
            onChange={(account) => {
              setSelectedAccount(parseInt(account))
            }}
            selectedValue={selectedAccount?.toString() || ''}
          />
        </AccountPlanOptionWrapper>
      )
    })
  }

  return (
    <AccountsAndPlansStyles>
      <AccountsAndPlansTitlesWrapper>
        <AccountAndPlansTitle>{t('reactivation.account_name')}</AccountAndPlansTitle>
        <AccountAndPlansTitle>{t('reactivation.previous_plan')}</AccountAndPlansTitle>
      </AccountsAndPlansTitlesWrapper>
      <AccountAndPlansWrapper>{renderAccountsWithPlans()}</AccountAndPlansWrapper>
    </AccountsAndPlansStyles>
  )
}
